/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FollowingInputs */

const en_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Following`)
};

const es_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiendo`)
};

const fr_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnements`)
};

const de_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folge ich`)
};

const id_following = /** @type {(inputs: FollowingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diikuti`)
};

/** @type {(inputs: FollowingInputs) => LocalizedString} */
const ja_following = en_following;

/** @type {(inputs: FollowingInputs) => LocalizedString} */
const zh_following = en_following;

/** @type {(inputs: FollowingInputs) => LocalizedString} */
const ar_following = en_following;

/** @type {(inputs: FollowingInputs) => LocalizedString} */
const it_following = en_following;

/** @type {(inputs: FollowingInputs) => LocalizedString} */
const ru_following = en_following;

/** @type {(inputs: FollowingInputs) => LocalizedString} */
const pt_following = en_following;

/** @type {(inputs: FollowingInputs) => LocalizedString} */
const ko_following = en_following;

/**
* | output |
* | --- |
* | "Following" |
*
* @param {FollowingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const following = /** @type {((inputs?: FollowingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FollowingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_following(inputs)
	if (locale === "es") return es_following(inputs)
	if (locale === "fr") return fr_following(inputs)
	if (locale === "de") return de_following(inputs)
	if (locale === "ja") return ja_following(inputs)
	if (locale === "zh") return zh_following(inputs)
	if (locale === "ar") return ar_following(inputs)
	if (locale === "id") return id_following(inputs)
	if (locale === "it") return it_following(inputs)
	if (locale === "ru") return ru_following(inputs)
	if (locale === "pt") return pt_following(inputs)
	return ko_following(inputs)
});